<template>
  <VCheckbox
    v-bind="$attrs"
    v-model="proxy"
    color="default"
    class="m-checkbox"
    hide-details="auto"
    v-on="$listeners"
  >
    <template #label>
      <span v-if="!$scopedSlots['infotext']" v-tooltip="{ disabled: !tooltip, text: tooltip ? tooltip : '' }" style="font-size: 11px" v-text="label" />
      <InfoBubble v-else key="info" :noGutters="true" cols="auto">
        <span v-tooltip="{ disabled: !tooltip, text: tooltip ? tooltip : '' }" class="mr-1" style="font-size: 11px" v-text="label" />
        <template #infotext>
          <slot name="infotext" />
        </template>
      </InfoBubble>
    </template>
    <template v-for="(_, name) in $slots" #[name]>
      <slot :name="name" />
    </template>
    <template v-for="(_, name) in $scopedSlots" #[name]="data">
      <slot :name="name" v-bind="data" />
    </template>
  </VCheckbox>
</template>

<style lang="stylus">

</style>

<script lang="ts">
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VCheckbox } from 'vuetify/lib';

export default defineComponent({
  name: 'MCheckbox',
  components: {
    VCheckbox,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    tooltip: {
      type: String,
    },
  },
  computed: {
    proxy: {
      get(): boolean {
        return this.value;
      },
      set(val: boolean) {
        this.$emit('input', val);
      },
    },
  },
});
</script>
